(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recovery-offer"]) return;
  try {
    
(() => {
  if (window.ZelRecovery) { window.ZelRecovery.refresh(); return; }
  const DAY = 86400000;
  const keys = { dismissed: 'zel_recovery_dismissed_v1', accepted: 'zel_recovery_accepted_v1' };
  const memory = {};
  const read = (key) => { try { return localStorage.getItem(key) || memory[key]; } catch (_) { return memory[key]; } };
  const write = (key, value) => { memory[key] = String(value); try { localStorage.setItem(key, String(value)); } catch (_) {} };
  const recent = (key) => { const at = Number(read(key)); return at > 0 && Date.now() - at < 7 * DAY; };
  const visible = (el) => {
    if (!el || el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
    const rect = el.getBoundingClientRect();
    const style = getComputedStyle(el);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && rect.bottom > 0 && rect.top < innerHeight;
  };
  const selectors = '#shopify-pc__banner, #shopify-pc__prefs, #onetrust-banner-sdk, #onetrust-pc-sdk, #CybotCookiebotDialog';
  let consentEvent = false;
  let engaged = false;
  let requested = false;
  let autoOpened = false;
  let previousFocus;
  let previousOverflow = '';
  const startedAt = Date.now();
  const currentDialog = () => document.querySelector('[data-recovery-dialog]');
  const tracking = (url) => Array.from(url.searchParams).filter(([key]) => /^utm_/.test(key) || ['fbclid', 'gclid', 'msclkid', 'preview_theme_id', '_fd', 'pb', 'discount'].includes(key));
  const decorate = (target, source = new URL(location.href)) => {
    tracking(source).forEach(([key, value]) => target.searchParams.set(key, value));
    return target;
  };
  const cleanPath = (url) => {
    const target = new URL(url, location.origin);
    if (target.origin !== location.origin) return location.pathname;
    const kept = new URL(target.pathname, location.origin);
    ['variant', 'quantity'].forEach((key) => { if (target.searchParams.has(key)) kept.searchParams.set(key, target.searchParams.get(key)); });
    decorate(kept, target);
    return kept.pathname + kept.search;
  };
  function cookieVisible() {
    const root = document.querySelector('[data-recovery-root]');
    let custom = root?.dataset.consentSelector || '';
    try { return Array.from(document.querySelectorAll(selectors + (custom ? ', ' + custom : ''))).some(visible); }
    catch (_) { return true; }
  }
  function consentResolved() {
    if (cookieVisible()) return false;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.shouldShowBanner !== 'function') return false;
    try {
      const consent = privacy.currentVisitorConsent?.() || {};
      return consentEvent || ['analytics', 'marketing', 'preferences'].some((key) => ['yes', 'no'].includes(consent[key])) || privacy.shouldShowBanner() === false;
    } catch (_) { return false; }
  }
  function otherOverlay() {
    return Array.from(document.querySelectorAll('#cart-drawer.active, #mobile-menu.active, #age-gate:not(.hidden), dialog[open]:not([data-recovery-dialog]), [aria-modal="true"]:not([data-recovery-dialog])')).some(visible);
  }
  function dismiss(suppress = true) {
    const dialog = currentDialog();
    if (!dialog?.open) return;
    dialog.close();
    document.body.style.overflow = previousOverflow;
    if (suppress) { write(keys.dismissed, Date.now()); requested = false; }
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    refresh();
  }
  function show() {
    const dialog = currentDialog();
    if (!dialog || dialog.open || !consentResolved() || otherOverlay()) return;
    const success = dialog.querySelector('[data-recovery-success]');
    const formState = dialog.querySelector('[data-recovery-form-state]');
    const accepted = dialog.dataset.accepted === 'true' || dialog.dataset.known === 'true' || Number(read(keys.accepted)) > 0;
    if (success) success.hidden = !accepted;
    if (formState) formState.hidden = accepted;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    requested = false;
    autoOpened = true;
    (dialog.querySelector('[data-recovery-error]') || (accepted ? dialog.querySelector('[data-recovery-success-title]') : dialog.querySelector('input[type="email"]')))?.focus();
    refresh();
  }
  function updateLinks() {
    const current = new URL(location.href);
    document.querySelectorAll('[data-refresh-offer]').forEach((link) => { link.href = decorate(new URL(link.href)).toString(); });
    document.querySelectorAll('[data-recovery-product]').forEach((root) => {
      const form = root.querySelector('[data-recovery-product-form]');
      const input = form?.querySelector('[data-recovery-cart-return]');
      if (input) {
        const cart = decorate(new URL(input.dataset.cartUrl, location.origin));
        input.value = cart.pathname + cart.search;
      }
    });
    const dialog = currentDialog();
    if (!dialog) return;
    const returnInput = dialog.closest('form')?.querySelector('input[name="return_to"]');
    if (returnInput) returnInput.value = cleanPath(current) + '#recovery-newsletter';
    const link = dialog.querySelector('[data-recovery-apply]');
    if (link) {
      const chosen = document.querySelector('[data-recovery-product-form]');
      const destination = new URL(chosen || /\/cart\/?$/.test(current.pathname) ? cleanPath(current) : dialog.dataset.destination, location.origin);
      decorate(destination);
      if (chosen?.elements.id) destination.searchParams.set('variant', chosen.elements.id.value);
      if (chosen?.elements.quantity) destination.searchParams.set('quantity', chosen.elements.quantity.value);
      const code = dialog.dataset.code;
      destination.searchParams.set('discount', code);
      link.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination.pathname + destination.search);
    }
  }
  function refresh() {
    const dialog = currentDialog();
    const blocked = !consentResolved() || otherOverlay();
    if (dialog?.open && blocked) { requested = true; dismiss(false); }
    const reopen = document.querySelector('.recovery-reopen');
    const mobile = matchMedia('(max-width: 760px)').matches;
    let stripShown = false;
    document.querySelectorAll('[data-recovery-product]').forEach((root) => {
      const main = root.querySelector('[data-recovery-main-add]');
      const strip = root.querySelector('[data-recovery-sticky]');
      if (!main || !strip) return;
      const rect = main.getBoundingClientRect();
      const headerBottom = document.querySelector('.header')?.getBoundingClientRect().bottom || 0;
      const outOfView = rect.bottom <= Math.max(0, headerBottom) || rect.top >= innerHeight;
      const keyboardOpen = window.visualViewport && visualViewport.height < innerHeight * 0.75;
      const shouldShow = mobile && outOfView && !blocked && !dialog?.open && !keyboardOpen && !document.hidden;
      if (strip.hidden === shouldShow) strip.hidden = !shouldShow;
      const button = strip.querySelector('button');
      if (button.disabled !== main.disabled) button.disabled = main.disabled;
      if (button.textContent !== main.textContent) button.textContent = main.textContent;
      stripShown ||= shouldShow;
    });
    document.body.classList.toggle('recovery-sticky-visible', stripShown);
    if (reopen) {
      const hide = blocked || !!dialog?.open || stripShown || (mobile && !!document.querySelector('[data-recovery-product]'));
      if (reopen.hidden !== hide) reopen.hidden = hide;
    }
    document.querySelectorAll('[data-recovery-inline]').forEach((button) => { button.disabled = blocked; });
    if (!dialog?.open && !blocked && !document.hidden) {
      const delay = Math.max(12, Number(dialog?.dataset.delay || 12)) * 1000;
      const canAuto = dialog?.dataset.autoShow === 'true' && dialog.dataset.known !== 'true' && !autoOpened && !recent(keys.dismissed) && !recent(keys.accepted) && engaged && Date.now() - startedAt >= delay;
      if (requested || canAuto) show();
    }
  }
  function init() {
    const dialog = currentDialog();
    if (dialog && dialog.dataset.bound !== 'true') {
      dialog.dataset.bound = 'true';
      if (dialog.dataset.accepted === 'true' && location.hash === '#recovery-newsletter') { write(keys.accepted, Date.now()); requested = true; } else { dialog.dataset.accepted = 'false'; }
      if (dialog.dataset.errors === 'true') requested = true;
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
      dialog.addEventListener('click', (event) => { if (event.target === dialog || event.target.closest('[data-recovery-close]')) dismiss(); });
      dialog.closest('form')?.addEventListener('submit', (event) => {
        if (dialog.dataset.submitting === 'true') { event.preventDefault(); return; }
        updateLinks();
        queueMicrotask(() => { if (!event.defaultPrevented) { dialog.dataset.submitting = 'true'; dialog.querySelector('[type="submit"]')?.setAttribute('aria-busy', 'true'); } });
      });
      dialog.querySelector('[data-recovery-copy]')?.addEventListener('click', async (event) => {
        try { await navigator.clipboard.writeText(dialog.dataset.code); event.target.textContent = event.target.dataset.copied; }
        catch (_) { dialog.querySelector('[data-recovery-code]')?.focus(); }
      });
    }
    document.querySelectorAll('[data-recovery-product]').forEach((root) => {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      const form = root.querySelector('[data-recovery-product-form]');
      const qty = Number(new URL(location.href).searchParams.get('quantity'));
      if (Number.isInteger(qty) && qty > 0 && qty <= 99 && form?.elements.quantity) {
        form.elements.quantity.value = qty;
        const label = root.querySelector('[data-qty-value]');
        if (label) label.textContent = qty;
      }
      form?.addEventListener('submit', updateLinks);
    });
    if (dialog) { dialog.dataset.submitting = 'false'; dialog.querySelector('[type="submit"]')?.removeAttribute('aria-busy'); }
    updateLinks();
    refresh();
  }
  window.ZelRecovery = { refresh: init };
  window.openDiscountPopup = () => { requested = true; refresh(); };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-recovery-reopen]')) window.openDiscountPopup();
    if (event.isTrusted && event.target.closest('[data-refresh-offer], [data-recovery-product], main a, main button, main summary, main video')) engaged = true;
  });
  document.addEventListener('scroll', () => { if (scrollY >= Math.min(200, innerHeight * 0.25)) engaged = true; refresh(); }, { passive: true });
  document.addEventListener('visitorConsentCollected', () => { consentEvent = true; refresh(); });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('pageshow', init);
  if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], refresh);
  setInterval(refresh, 500);
  init();
})();

  } catch(e) { console.error(e); }
})();
})();
